import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateAndTime } from '@/utils/formatDate';
import { Schedule } from '../../types';
import styles from './ScheduleItem.module.scss';
import { getServiceCell } from '../../ScheduleTable/getServiceCell';
import ModalChart from '../../ModalChart';

type ScheduleItemProps = {
  nombre: Schedule['nombre'];
  codigo: Schedule['codigo'];
  servicio: Schedule['servicio'];
  comienzoOperaciones: Schedule['comienzoOperaciones'];
  finOperaciones: Schedule['finOperaciones'];
  aperturaStacking: Schedule['aperturaStacking'];
  cierreStacking: Schedule['cierreStacking'];
  cutOff: Schedule['cutOff'];
  fechaFinDescarga: Schedule['fechaFinDescarga'];
  showDetail?: boolean;
};

const ScheduleItem: FC<ScheduleItemProps> = ({
  nombre,
  codigo,
  servicio,
  comienzoOperaciones,
  finOperaciones,
  aperturaStacking,
  cierreStacking,
  cutOff,
  fechaFinDescarga,
  showDetail,
}) => {
  const { t } = useTranslation('schedule');

  return (
    <div className={styles.scheduleItem}>
      <header className={styles.headerTable}>
        {nombre}
        <span>
          {!!showDetail && <ModalChart buqueName={nombre} codViaje={codigo} />}
        </span>
      </header>
      <div>
        <p className={styles.heading}>{t('tableHeadings.service')}</p>
        <div className={styles.text}>{getServiceCell(servicio)}</div>
      </div>
      <div>
        <p className={styles.heading}>{t('tableHeadings.operations')}</p>
        <div className={styles.grid}>
          <div>
            <p className={styles.heading}>{t('tableHeadings.start')}</p>
            <p className={styles.date}>
              {formatDateAndTime(comienzoOperaciones)}
            </p>
          </div>
          <div>
            <p className={styles.heading}>{t('tableHeadings.end')}</p>
            <p className={styles.date}>{formatDateAndTime(finOperaciones)}</p>
          </div>
          <div>
            <p className={styles.heading}>
              {t('tableHeadings.importDelivery')}
            </p>
            <p className={styles.date}>{formatDateAndTime(fechaFinDescarga)}</p>
          </div>
        </div>
      </div>
      <div>
        <p className={styles.heading}>{t('tableHeadings.stacking')}</p>
        <div className={styles.grid}>
          <div>
            <p className={styles.heading}>{t('tableHeadings.opening')}</p>
            <p className={styles.date}>{formatDateAndTime(aperturaStacking)}</p>
          </div>
          <div>
            <p className={styles.heading}>{t('tableHeadings.closing')}</p>
            <p className={styles.date}>{formatDateAndTime(cierreStacking)}</p>
          </div>
          <div>
            <p className={styles.heading}>{t('tableHeadings.lateEntry')}</p>
            <p className={styles.date}>{formatDateAndTime(cutOff)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleItem;
